export function isDataReportParent(item) {
  if (!item) return false
  return (
    item.name === 'dataReport' ||
    item.path === '/dataReport' ||
    item.pageName === '数据报表' ||
    (item.meta && item.meta.title === '数据报表')
  )
}

export function withReportSuffix(title) {
  if (!title) return title
  const text = String(title)
  return text.slice(-2) === '报表' ? text : text + '报表'
}

export function singleReportChild(pages) {
  if (!Array.isArray(pages)) return null
  const parent = pages.find(isDataReportParent)
  if (parent && parent.children && parent.children.length === 1) {
    return parent.children[0]
  }
  return null
}

export function applySingleReportNavTitle(menuPages) {
  const child = singleReportChild(menuPages)
  if (!child) return menuPages
  const titled = withReportSuffix((child.meta && child.meta.title) || child.pageName)
  if (child.meta) child.meta.title = titled
  if (child.pageName) child.pageName = titled
  return menuPages
}

export function reportHeaderTitle(menuPages, route, fallback) {
  const path = route && route.path ? String(route.path) : ''
  if (path.indexOf('/dataReport') !== 0) return fallback
  const child = singleReportChild(menuPages)
  if (!child) return fallback
  const title = (child.meta && child.meta.title) || child.pageName || fallback
  return withReportSuffix(title)
}
